import React from "react";
import { APPLE_PAY_MARK, GOOGLE_PAY_MARK } from "../data/mock";

/**
 * Small Apple Pay + Google Pay marks for marketing surfaces.
 * Variants:
 *   - "default" — color marks on a transparent background (use on white/light surfaces)
 *   - "pill"    — color marks inside a tiny white pill (use on dark backgrounds)
 */
export const PaymentMarks = ({ variant = "default", size = "sm", className = "" }) => {
  const heightCls = size === "xs" ? "h-4" : size === "md" ? "h-7" : "h-5";

  const inner = (
    <>
      <img src={APPLE_PAY_MARK} alt="Apple Pay accepted" className={`${heightCls} w-auto`} />
      <img src={GOOGLE_PAY_MARK} alt="Google Pay accepted" className={`${heightCls} w-auto`} />
    </>
  );

  if (variant === "pill") {
    return (
      <span
        className={`inline-flex items-center gap-1.5 bg-white rounded-full px-2 py-1 shadow-sm ${className}`}
      >
        {inner}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {inner}
    </span>
  );
};
